// extracted by mini-css-extract-plugin
export default {"item":"Post_item__Yu4oG","likeBtn":"Post_likeBtn__ZGgkl","postContent":"Post_postContent__yBsy9","postLikes":"Post_postLikes__P0kqs"};